<template>
  <PopoverContract :local-id="id" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import PopoverContract from '@/components/PopoverContract.vue'

const HireContractPopoverColumn = graphql(`
  fragment HireContractPopoverColumn on Hire {
    id
  }
`)

const props = defineProps<{ row: FragmentType<typeof HireContractPopoverColumn> }>()
const column = computed(() => useFragment(HireContractPopoverColumn, props.row))
const id = computed(() => parseInt(<string>atob(column.value.id).split('Hire:').pop(), 10))
</script>

<style lang="scss">
.hire-column-worker-information {
  text-align: left;
}
</style>
